<app-navbar></app-navbar>

<div class="main">
    <div class="row g-0">
        <div class="col content-right px-0" role="main">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
